import { createSlice } from '@reduxjs/toolkit';

import resetStore from '../resetStore';

const initialState = {
  owner_id: '',
  status: 'PROCESSING',
  need_delivery: null,
  // pass: {
  //   name: '',
  //   car_num: '',
  // },
  address: {
    name: '',
    last_name: '',
    phone: '',
    full_address: '',
    entrance: '',
    floor: null,
    intercom: '',
    elevator_type: '',
  },
  plan_delivery_date: '',
  time_min: '',
  time_max: '',
  comment: '',
};

const deliveryFormSlice = createSlice({
  name: 'deliveryForm',
  initialState,
  reducers: {
    updateForm(state, action) {
      return {
        ...state,
        ...action.payload,
        address: {
          ...state.address,
          ...action.payload.address,
        },
      };
    },
    resetForm() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStore, () => initialState);
  },
});

export const { updateForm, resetForm } = deliveryFormSlice.actions;
export default deliveryFormSlice.reducer;
